import { createContext, useContext, useState } from 'react';
import {
  ResourceDialogProps,
  ResourcesContextData,
  ResourcesData,
  ResourcesProviderProps,
} from './types';
import { initialState } from './constants';
import { useGetResourcesUsers } from '@services/resources/users';
import { useGetResourcesEquipment } from '@services/resources/equipment';

const ResourcesContext = createContext<ResourcesContextData | Record<string, never>>({});

export const ResourcesProvider = ({ children }: ResourcesProviderProps) => {
  const [state, setState] = useState<ResourcesData>(initialState);

  const setDialog = (props: ResourceDialogProps) => {
    setState((prev) => {
      if (props.item === 'user') {
        return {
          ...prev,
          dialog: {
            item: 'user',
            type: props.type,
            values: props.values || prev.dialog.values,
          },
        };
      } else {
        return {
          ...prev,
          dialog: {
            item: 'equipment',
            type: props.type,
            values: props.values || prev.dialog.values,
          },
        };
      }
    });
  };

  const users = useGetResourcesUsers();
  const equipment = useGetResourcesEquipment();

  return (
    <ResourcesContext.Provider
      value={{
        ...state,
        setState,
        setDialog,
        users: {
          records: users.data?.records || [],
          isLoading: users.isLoading,
        },
        equipment: {
          records: equipment.data?.records || [],
          pagy: equipment?.data?.pagy,
          isLoading: equipment.isLoading,
        },
      }}>
      {children}
    </ResourcesContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useResources = () => useContext(ResourcesContext);
